import { useTranslation } from 'libs/translations';

import { Icon, type IconName } from 'components';
import {
  VENUS_COMMUNITY_URL,
  VENUS_DOC_URL,
  VENUS_GITHUB_URL,
  VENUS_TELEGRAM_URL,
  VENUS_X_URL,
} from 'constants/production';
import { routes } from 'constants/routing';
import { Link } from 'containers/Link';
import { forwardRef } from 'react';

interface SocialLink {
  iconName: IconName;
  href?: string;
}

interface LinkConfig {
  label: string;
  href?: string;
  to?: string;
}

export const Footer = forwardRef<HTMLDivElement>((_, ref) => {
  const { t } = useTranslation();

  const socialLinks: SocialLink[] = [
    {
      iconName: 'venus',
      href: VENUS_COMMUNITY_URL,
    },
    {
      iconName: 'telegram',
      href: VENUS_TELEGRAM_URL,
    },
    {
      iconName: 'x',
      href: VENUS_X_URL,
    },
    {
      iconName: 'github',
      href: VENUS_GITHUB_URL,
    },
  ];

  const footerLinks: LinkConfig[] = [
    {
      label: t('footer.links.documentation'),
      href: VENUS_DOC_URL,
    },
    {
      label: t('footer.links.skills'),
      to: routes.skills.path,
    },
    {
      label: t('footer.links.privacyPolicy'),
      to: routes.privacyPolicy.path,
    },
    {
      label: t('footer.links.termsOfUse'),
      to: routes.termsOfUse.path,
    },
  ];

  return (
    <footer
      ref={ref}
      className="bg-background-active mt-10 p-5 space-y-4 sm:flex sm:justify-between sm:items-center sm:space-y-0 md:px-6 xl:px-10"
    >
      <div className="flex items-center gap-4 flex-wrap">
        {footerLinks.map(footerLink => {
          const { label, ...restProps } = footerLink;

          return (
            <Link className="text-grey text-sm" key={label} {...restProps}>
              {label}
            </Link>
          );
        })}
      </div>

      <div className="flex flex-none items-center">
        {socialLinks.map(socialLink => (
          <a
            className="bg-lightGrey hover:bg-blue active:bg-darkBlue ml-4 flex h-6 w-6 items-center justify-center rounded-sm transition-colors first-of-type:ml-0"
            href={socialLink.href}
            key={socialLink.href}
            target="_blank"
            rel="noreferrer"
          >
            <Icon name={socialLink.iconName} className="text-white h-3 w-3" />
          </a>
        ))}
      </div>
    </footer>
  );
});
